import {
  Table,
  Paging,
  EllipsisSpan,
  usePaging,
  Form,
  Input,
  CustomFilter,
  Modal,
  TreeSelect,
} from '@maxtropy/components';
import { FC, useState, Key, useEffect } from 'react';
import { ColumnType } from 'antd/es/table';
import { getAllOrganizationTree } from '../../../../api/customer';
import { FormInstance } from 'antd';
import { DefaultOptionType } from 'rc-tree-select/es/TreeSelect';
import { formatTreeData } from '../../../../lib/util';
import { getStaffList, StaffListRequest, StaffResponse } from '../../../../api/staff';

export const userColumns: ColumnType<StaffResponse>[] = [
  {
    title: '姓名',
    dataIndex: 'customerUserName',
    width: 200,
    render: (v: string) => <EllipsisSpan value={v} />,
  },
  {
    title: '工号',
    dataIndex: 'staffCode',
    width: 200,
    render: (v: string) => <EllipsisSpan value={v} />,
  },
  {
    title: '手机号',
    width: 100,
    dataIndex: 'customerUserCellphone',
    render: (v: string) => <EllipsisSpan value={v} />,
  },
  {
    title: '所属组织',
    width: 300,
    dataIndex: 'customerName',
    render: (v: string) => <EllipsisSpan value={v} />,
  },
];

interface UserModalProps {
  selectedData: StaffResponse[];
  setSelectedData: (value: StaffResponse[]) => void;
  form: FormInstance<any>;
  onCancel: () => void;
}

interface SearchParams extends Omit<StaffListRequest, 'size' | 'page' | 'mcids'> {
  mcids?: string[];
}

const UserModal: FC<UserModalProps> = ({ selectedData, setSelectedData, form, onCancel }) => {
  const pagingInfo = usePaging(100);
  const { pageOffset, pageSize, setTotalCount, setPageOffset } = pagingInfo;

  const [searchParams, setSearchParams] = useState<SearchParams>();
  const [loading, setLoading] = useState<boolean>(false);

  const [searchForm] = Form.useForm();

  const [data, setData] = useState<StaffResponse[]>([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [selectedRows, setSelectedRows] = useState<StaffResponse[]>([]);
  const [treeData, setTreeData] = useState<DefaultOptionType[]>([]);

  useEffect(() => {
    setLoading(true);
    getStaffList({
      ...searchParams,
      page: pageOffset,
      size: pageSize,
      mcids: searchParams?.mcids,
    })
      .then(res => {
        setData(res.list ?? []);
        setTotalCount(res.total);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [pageOffset, pageSize, searchParams]);

  useEffect(() => {
    getAllOrganizationTree().then(res => {
      setTreeData(formatTreeData([res]));
    });
  }, []);

  useEffect(() => {
    if (selectedData.length > 0) {
      setSelectedRowKeys(selectedData.map(record => record.id));
      setSelectedRows(selectedData);
    }
  }, []);

  const onOk = () => {
    setSelectedData(selectedRows);
    onCancel();
  };

  const rowSelection = {
    onChange: (selectedRowKeys: Key[], selectedRows: StaffResponse[]) => {
      setSelectedRowKeys(selectedRowKeys);
      setSelectedRows(selectedRows);
    },
    preserveSelectedRowKeys: true,
    selectedRowKeys: selectedRowKeys,
  };

  const onFinish = (record: SearchParams) => {
    setPageOffset(1);
    setSearchParams(record);
  };

  const onReset = () => {
    setPageOffset(1);
  };

  return (
    <Modal title="用户信息" open={true} size="big" onOk={onOk} onCancel={onCancel} destroyOnClose>
      <CustomFilter<SearchParams> form={searchForm} onFinish={onFinish} onReset={onReset} colSpan={8}>
        <Form.Item name="name" label="姓名">
          <Input placeholder="请输入" maxLength={20} />
        </Form.Item>
        <Form.Item name="cellphone" label="手机号">
          <Input placeholder="请输入" maxLength={20} />
        </Form.Item>
        <Form.Item name="mcids" label="所在组织">
          <TreeSelect placeholder="请选择" treeData={treeData} multiple />
        </Form.Item>
      </CustomFilter>
      <Table
        loading={loading}
        rowSelection={{
          type: 'checkbox',
          ...rowSelection,
        }}
        sticky
        scroll={{ y: 300 }}
        rowKey="id"
        columns={userColumns}
        dataSource={data}
        showSelectedCount
        selectedCount={selectedRows.length}
      >
        <Paging pagingInfo={pagingInfo} />
      </Table>
    </Modal>
  );
};

export default UserModal;
